import type { PrintDay } from '@/components/chefs/print/print-root'
import { PrintHeader } from '@/components/print/print-header'
import { countUniqueRecipes, formatLongDate } from '@/lib/chefs/print-plan'
import { countCampusesServings } from '@/lib/chefs/totals'

interface PrintDayCoverPageProps {
  day: PrintDay
  variant: 'orders' | 'recipes'
  kitchenName: string
}

export function PrintDayCoverPage({ day, variant, kitchenName }: PrintDayCoverPageProps) {
  const longDate = formatLongDate(day.date)
  const title = variant === 'orders' ? `Orders for ${longDate}` : `Recipes for ${longDate}`

  const stats: { label: string; value: number }[] = []
  if (variant === 'orders') {
    stats.push({ label: day.campuses.length === 1 ? 'Location' : 'Locations', value: day.campuses.length })
    stats.push({ label: 'Total servings', value: countCampusesServings(day.campuses) })
  } else {
    const recipeCount = countUniqueRecipes(day.campuses)
    stats.push({ label: recipeCount === 1 ? 'Unique recipe' : 'Unique recipes', value: recipeCount })
  }

  return (
    <div className="font-sans text-black">
      <PrintHeader kitchenName={kitchenName} dateLabel={day.dateLabel} />
      <header className="mt-16 border-b-2 border-black pb-4">
        <p className="text-xs uppercase tracking-wide">
          {variant === 'orders' ? 'Section · Orders' : 'Section · Recipes'}
        </p>
        <h1 className="mt-2 text-4xl font-semibold leading-tight">{title}</h1>
      </header>
      <section className="mt-8 flex flex-wrap gap-4">
        {stats.map((stat) => (
          <div key={stat.label} className="rounded-md border border-black/15 px-4 py-3">
            <div className="text-2xl font-semibold leading-none">{stat.value}</div>
            <div className="mt-1 text-xs uppercase tracking-wide text-muted-foreground">{stat.label}</div>
          </div>
        ))}
      </section>
    </div>
  )
}
